import { FC, ReactElement } from 'react';
import { Outlet } from 'react-router-dom';
import { images } from '@constants/images';
import { useTranslation } from 'react-i18next';
import useScreenSize from '@hooks/useScreenSize';
import { Card } from '@components/common';
import { RazorPayLogo } from '@components/common/svg-icons';
import LoginLayout from './login-layout';

const AuthLayout: FC = (): ReactElement => {
  const { t: translate } = useTranslation();
  const { isMobile } = useScreenSize();

  return (
    <div className="relative flex w-auto flex-col">
      <div className="flex bg-primary-0 pb-4">
        <div className="hidden h-screen w-3/5 p-3 lg:block">
          <div className="relative h-full w-full">
            <img
              src={images.loginLounge}
              alt="lounge Pic"
              className="h-full w-full rounded-xl object-cover"
            />
            <p className="absolute bottom-0 left-0 w-full rounded-b-xl p-6 text-3xl font-semibold text-white">
              {translate('loginPage.steps.mainText')}
            </p>
          </div>
        </div>
        <div
          className={`flex w-full flex-col p-6 lg:w-2/5 lg:justify-center ${
            isMobile ? 'mt-14 min-h-screen overflow-y-auto' : 'h-auto'
          }`}
        >
          <LoginLayout />
          <Card>
            <div>
              <Outlet />
            </div>
          </Card>
        </div>
      </div>

      {/* Powered by Razorpay footer */}
      <div className="fixed bottom-4 right-4 flex items-center gap-1 rounded bg-white/80 px-2 py-1 shadow">
        <span className="text-sm text-gray-600">Powered by</span>
        <RazorPayLogo />
      </div>
    </div>
  );
};

export default AuthLayout;
